import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../../../../utils/api/auth';
import { fetchPendingEvents } from '../../../../../utils/api/adminApi';
import { DEFAULT_IMAGE_DATA_URI } from '../../../../../components/imageUtils';
import GlobalHeader from '../../../../../components/GlobalHeader.jsx';
import EventApprovalTable from '../../../Event/components/EventApprovalTable.jsx';
import Pagination from '../../../../../components/Pagination.jsx';
import '../css/EventApproval.css';

const EventApproval = () => {
  const nav = useNavigate();
  const [events, setEvents] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5);

  useEffect(() => {
    const fetchEventsData = async () => {
      try {
        const data = await fetchPendingEvents();

        const displayEvents = data.map((event) => {
          let formattedDate = 'N/A';
          try {
            if (event.StartDate || event.startdate || event.start_date || event.date) {
              const rawDate = event.StartDate || event.startdate || event.start_date || event.date;
              const dateObj = new Date(rawDate);
              if (!Number.isNaN(dateObj.getTime())) {
                formattedDate = dateObj.toLocaleDateString('en-ZA', {
                  day: 'numeric',
                  month: 'short',
                  year: 'numeric',
                });
              }
            }
          } catch {
            formattedDate = event.StartDate || event.startdate || event.date || 'N/A';
          }

          return {
            eventid: event.EventID || event.eventid || event.event_id || event.id,
            event_name: event.Name || event.name || event.event_name || 'Untitled Event',
            status: 'Pending',
            location: event.Location || event.location || event.venue || 'N/A',
            date: event.StartDate || event.startdate || event.start_date || event.date || 'N/A',
            time: event.StartTime || event.time || event.start_time || 'N/A',
            event_type: event.Type || event.type || event.event_type || 'Standard',
            file_url: event.coverimage || event.MainImage || event.file_url || DEFAULT_IMAGE_DATA_URI,
            formattedDate,
          };
        });

        setEvents(displayEvents);
        setLoading(false);
      } catch (err) {
        setError(err.message || 'Failed to load events');
        setLoading(false);
      }
    };

    fetchEventsData();
  }, []);

  const handleLogout = () => {
    logout(nav);
  };

  const handleViewEvent = (event) => {
    if (!event?.eventid) return;
    nav('/adminvieweventrequest', { state: { eventid: event.eventid } });
  };

  return (
    <div className="event-approval-page">
      <GlobalHeader
        title="Events Pending Approval"
        subtitle="Review and manage event requests"
        backTo="/admin"
        onLogout={handleLogout}
      />

      <main className="event-approval-main">
        {error && (
          <div className="modern-error">
            <p>{error}</p>
          </div>
        )}

        {loading && (
          <div className="modern-loading">
            <div className="modern-spinner" />
            <p>Loading events...</p>
          </div>
        )}

        {!loading && events.length === 0 && !error && (
          <div className="modern-no-data">
            <p>No events available for approval at this time.</p>
          </div>
        )}

        {!loading && events.length > 0 && (
          <>
            <EventApprovalTable 
              events={events} 
              onViewEvent={handleViewEvent}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
            />
            <Pagination
              currentPage={currentPage}
              totalPages={Math.ceil(events.length / itemsPerPage)}
              totalItems={events.length}
              itemsPerPage={itemsPerPage}
              onPageChange={setCurrentPage}
            />
          </>
        )}
      </main>
    </div>
  );
};

export default EventApproval;
